import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import ScenariosContainer from "./ScenariosContainer";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.SCENARIO],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <ScenariosContainer />
    </App>
  );
};
